<template>
  <div
    v-if="
      GET_ACCOUNT_DATA.id == 1 ||
        has_perm('create_apartment_realestate') ||
        has_perm('update_apartment_realestate')
    "
  >
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(pagetitle) }}</h3>
      </div>
      <form class="form-horizontal">
        <div class="box-body">
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_realestate.code")
            }}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <input
                v-model="apartment.realestate_code"
                type="text"
                class="form-control"
                :placeholder="$t('apartment_realestate.code')"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_realestate.size")
            }}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <input
                v-model="apartment.size"
                type="number"
                min="0"
                class="form-control"
                :placeholder="$t('apartment_realestate.size')"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_realestate.type")
            }}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <b-form-select
                :options="realestateTypeList"
                required
                v-model="apartment.realestate_type"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_realestate.project")
            }}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <b-form-select
                :options="projectList"
                required
                v-model="apartment.project"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_realestate.block")
            }}</label>
            <div class="col-sm-2 col-md-2 col-lg-2">
              <b-form-input
                type="text"
                v-model="apartment.block"
                :placeholder="$t('apartment_realestate.block')"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_realestate.floor")
            }}</label>
            <div class="col-sm-2 col-md-2 col-lg-2">
              <b-form-input
                type="text"
                v-model="apartment.floor"
                :placeholder="$t('apartment_realestate.floor')"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_realestate.room_number")
            }}</label>
            <div class="col-sm-2 col-md-2 col-lg-2">
              <b-form-input
                type="number"
                v-model="apartment.bedroom_count"
                min="0"
                :placeholder="$t('apartment_realestate.room_number')"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
              $t("apartment_realestate.note")
            }}</label>
            <div class="col-sm-4 col-md-4 col-lg-4">
              <b-form-input
                type="text"
                v-model="apartment.other_details"
                :placeholder="$t('apartment_realestate.note')"
              />
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onApartmentCancel"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            v-if="
              (has_perm('create_apartment_realestate') ||
                GET_ACCOUNT_DATA.id == 1) &&
                apartment.id == 0
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onApartmentSubmit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.add") }}
          </button>
          <button
            v-if="
              (has_perm('update_apartment_realestate') ||
                GET_ACCOUNT_DATA.id == 1) &&
                apartment.id != 0
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onApartmentSubmit"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </form>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <router-view></router-view>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import constants from "@/lib/constantsData";

export default {
  name: "ApartmentAdd",
  data() {
    return {
      infoShow: false,
      realestateTypeList: constants.realestateTypeText,
      projectList: [],
      isExistTenant: false,
      pagetitle: "apartment_realestate.editaddnew[0]",
      apartment: {
        id: 0,
        realestate_code: "",
        size: 0,
        realestate_type: 2,
        project: 1,

        bedroom_count: 0,
        block: "",
        floor: "",
        other_details: ""
      },
      isLoading: false
    };
  },

  watch: {
    APARTMENT_REALESTATE_DETAIL_DATA: function() {
      this.apartment.realestate_code = this.APARTMENT_REALESTATE_DETAIL_DATA.realestate_code;
      this.apartment.size = this.APARTMENT_REALESTATE_DETAIL_DATA.size;
      this.apartment.realestate_type = this.APARTMENT_REALESTATE_DETAIL_DATA.realestate_type;
      this.apartment.project = this.APARTMENT_REALESTATE_DETAIL_DATA.project;
      this.apartment.bedroom_count = this.APARTMENT_REALESTATE_DETAIL_DATA.bedroom_count;
      this.apartment.block = this.APARTMENT_REALESTATE_DETAIL_DATA.block;
      this.apartment.floor = this.APARTMENT_REALESTATE_DETAIL_DATA.floor;
      this.apartment.other_details = this.APARTMENT_REALESTATE_DETAIL_DATA.other_details;

      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "APARTMENT_REALESTATE_DETAIL_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ADD_APARTMENT_REALESTATE",
      "UPDATE_APARTMENT_REALESTATE",
      "GET_APARTMENT_REALESTATE_DETAIL",
      "ON_SHOW_TOAST",
      "GET_PROJECT_LIST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onApartmentCancel: function() {
      this.$router.push({
        name: "ApartmentRealestateList"
      });
    },
    validateData: function() {
      let validatedResult = "OK";
      let validation_keys = [
        "realestate_code",
        "size",
        "realestate_type",
        "project"
      ];
      for (let key in this.apartment) {
        if (validation_keys.indexOf(key) < 0) {
          continue;
        }
        if (this.apartment[key] === null || this.apartment[key] === "") {
          validatedResult = `Thiếu ${key}`;
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    onApartmentSubmit: function(event) {
      let result = this.validateData();
      if (result == "OK") {
        let data = {
          realestate_code: this.apartment.realestate_code,
          size: this.apartment.size,
          realestate_type: this.apartment.realestate_type,
          project: this.apartment.project,
          bedroom_count: this.apartment.bedroom_count,

          block: this.apartment.block,
          floor: this.apartment.floor,
          other_details: this.apartment.other_details
        };
        if (parseInt(this.apartment.id) == 0) {
          this.ADD_APARTMENT_REALESTATE({ data: data })
            .then(
              function() {
                this.$router.push({ name: "ApartmentRealestateList" });
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                let error_data = error.response.data;
                this.ON_SHOW_TOAST({
                  message: error_data.msg,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_APARTMENT_REALESTATE({
            id: this.apartment.id,
            data: data
          })
            .then(
              function() {
                this.$router.push({ name: "ApartmentRealestateList" });
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function(error) {
                let error_data = error.response.data;
                this.ON_SHOW_TOAST({
                  message: error_data.msg,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    }
  },
  mounted() {
    this.GET_PROJECT_LIST().then(
      function(res) {
        for (let i = 0, length = res.data.length; i < length; i++) {
          let objProject = {};
          objProject.value = res.data[i].id;
          objProject.text = res.data[i].project_name;

          this.projectList.push(objProject);
        }
      }.bind(this)
    );
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.apartment.id = parseInt(this.$route.params.id);
      this.pagetitle = "apartment_realestate.editaddnew[1]";
      this.infoShow = true;
      this.isLoading = true;
      let id = this.$route.params.id;
      if (parseInt(id) !== 0) {
        this.isLoading = true;
        this.GET_APARTMENT_REALESTATE_DETAIL({id: id}).then(
            function() {
              this.isLoading = false;
            }.bind(this)
          )
          .catch(function(error) {
            this.isLoading = false;
          });
      }
    } else {
      //
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentRealestateAdd.vue